import axios from "axios";
import { API_GET_MODELS_DATA } from "../../config/api";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  hideProgress,
  showProgress,
} from "shared-components/src/components/feedback/store/circularProgress.actions";
import {
  FETCH_MODELS_DATA_REQUEST,
  fetchModelsDataFailure,
  fetchModelsDataSuccess,
} from "../../store/actions/realtimeModelsData.actions";
import { showAlertInfo } from "shared-components/src/components/feedback/store/alertInfo.actions";
import { alertInfoTypes } from "shared-components/src/components/feedback/alertInfoTypes.enum";

const getModelsData = async (token, thing) => {
  const url = `${API_GET_MODELS_DATA}?thing=${thing}`;
  const headers = {
    "content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const response = await axios.get(url, { headers });
  return response.data;
};

function* handleModelsData(action) {
  try {
    yield put(showProgress());
    const token = yield select((state) => state.auth.token);
    const thing = action?.payload;
    const response = yield call(getModelsData, token, thing);
    yield put(fetchModelsDataSuccess(response));
    yield put(hideProgress());
  } catch (error) {
    yield put(
      showAlertInfo({ type: alertInfoTypes.ERROR, message: error.message })
    );
    yield put(hideProgress());
    yield put(fetchModelsDataFailure(error.message));
  }
}

export function* watchGetModelsData() {
  yield takeLatest(FETCH_MODELS_DATA_REQUEST, handleModelsData);
}
